import { apiClient } from "./api-client";

export interface CreateAdminRequestPayload {
  companyName: string;
  companyRegistrationNumber?: string;
  companyAddress?: string;
  sector?: string;
  companyEmail?: string;
  companyPhone?: string;
  companyWebsite?: string;
  representative?: {
    name: string;
    role?: string;
    email: string;
    phone?: string;
  };
  account?: {
    username: string;
    password?: string;
    useSSO: boolean;
  };
}

export const adminRequestApi = {
  async createRequest(payload: CreateAdminRequestPayload) {
    const { data } = await apiClient.post('/users/admin-request', payload);
    return data;
  },

  async uploadDocuments(requestId: string | number, files: File[]) {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    const { data } = await apiClient.post(`/users/admin-request/${requestId}/documents`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  async acceptContract(requestId: string | number) {
    const { data } = await apiClient.post(`/users/admin-request/${requestId}/accept-contract`, {
      accepted: true,
    });
    return data;
  },

  async listRequests(status?: string) {
    const params = status ? { status } : undefined;
    const { data } = await apiClient.get('/admin/admin-requests', { params });
    return data;
  },

  async getRequest(id: string | number) {
    const { data } = await apiClient.get(`/admin/admin-requests/${id}`);
    return data;
  },

  async approveRequest(id: string | number, comment?: string) {
    const { data } = await apiClient.post(`/admin/admin-requests/${id}/approve`, { comment });
    return data;
  },

  async denyRequest(id: string | number, reason: string) {
    const { data } = await apiClient.post(`/admin/admin-requests/${id}/deny`, { reason });
    return data;
  },
};

export default adminRequestApi;

